import type { InitCommandOptions } from '@cli-types/core-engine/commands.js'
import {
  DATABASE_PROVIDERS,
  DEPLOY_PROVIDERS,
  RAILWAY_BUCKET_REGIONS,
  STORAGE_PROVIDERS
} from '@cli-constants/providers.js'
import { assertChoice } from '@cli-utils/shared.js'

export function validateInitProviderFlags(options: InitCommandOptions): void {
  assertChoice('--database-provider', options.databaseProvider, DATABASE_PROVIDERS)
  assertChoice('--storage-provider', options.storageProvider, STORAGE_PROVIDERS)
  assertChoice('--deploy-provider', options.deployProvider, DEPLOY_PROVIDERS)
  assertChoice('--railway-bucket-region', options.railwayBucketRegion, RAILWAY_BUCKET_REGIONS)

  if (options.databaseUrl && options.databaseProvider && options.databaseProvider !== 'manual') {
    throw new Error('--database-url can only be used with --database-provider manual.')
  }

  if (options.databasePlan && options.databaseProvider && options.databaseProvider !== 'vercel') {
    throw new Error('--database-plan can only be used with --database-provider vercel.')
  }

  if (options.useExistingResources && !options.yes) {
    throw new Error('--use-existing-resources requires --yes.')
  }

  if (
    options.useExistingResources &&
    options.databaseProvider &&
    options.databaseProvider !== 'manual'
  ) {
    throw new Error(
      '--use-existing-resources requires --database-provider manual for an existing DATABASE_URL.'
    )
  }
}
